/**
 * AI商品ならカートボタンを隠す
 * - slug に "_ai" を含む場合のみ適用
 */
(() => {
  // 商品詳細ページ以外は何もしない
  if (!window.location.pathname.includes('/products/')) return;

  const slug = window.location.pathname.split('/').pop() || '';
  const isAi = slug.includes('_ai');

  if (!isAi) return;

  // HTMLにクラスを付与
  document.documentElement.classList.add('is-ai-product');

  // すでに注入済みなら二重に入れない
  if (document.getElementById('ai-hide-cart-style')) return;

  const style = document.createElement('style');

  style.id = 'ai-hide-cart-style';

  style.textContent = `
    html.is-ai-product .product-form__submit {
      visibility: hidden !important;
      pointer-events: none !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }
  `;

  // 可能ならheadに追加
  (document.head || document.documentElement).appendChild(style);
})();

/**
 * 許可する商品カテゴリ
 */
const allowedKeys = [
  'keyholder',
  'keyholder_ai',
  'omamori_keyholder',
  'aurora_keyholder',
  'fuchinashi_keyholder',
  'stand',
  'stand_ai',
  'aurora_stand',
  'ministand',
  'stand_keyholder',
  'aurora_stakey',
  'charm',
  'aurora_charm',
  'umbrella_marker',
  'aurora_umbrella_marker',
  'block',
  'mascot',
  'card',
  'diorama_ai',
  'diorama',
  'diorama_square',
];

/**
 * 台座形状の種類
 */
const baseShapeName = [
  {
    value: 'ellipse',
    label: '楕円',
  },
  {
    value: 'rectangle',
    label: '長方形',
  },
  {
    value: 'circle',
    label: '丸',
  },
  {
    value: 'square',
    label: '四角',
  },
  {
    value: 'hexagon',
    label: '六角形',
  },
  {
    value: 'cloud',
    label: '雲',
  },
  {
    value: 'star',
    label: '星',
  },
  {
    value: 'heart',
    label: 'ハート',
  },
  {
    value: 'flower',
    label: '花',
  },
  {
    value: 'cherryblo',
    label: '桜',
  },
  {
    value: 'cat',
    label: 'ネコ',
  },
  {
    value: 'bear',
    label: 'クマ',
  },
];

const SMART_BUTTON_SELECTOR =
  '.smart-design-button[data-smart-design-launch="true"]';

/**
 * 最大一致キーを返す
 *
 * @param {string} slug
 * @param {string[]} keys
 * @returns {string|null}
 */
const getBestMatchedKey = (slug, keys) => {
  const matched = keys.filter((key) => slug.includes(key));

  if (matched.length === 0) {
    return null;
  }

  // 最も長いキーを採用
  // omamori_keyholderがkeyholderより優先される
  matched.sort((a, b) => b.length - a.length);

  return matched[0];
};

/**
 * 入稿方法selectを取得
 *
 * @returns {HTMLSelectElement|null}
 */
const getSubmissionTypeSelect = () => {
  return (
    document.querySelector('[name="select_submission_type"]') ||
    document.querySelector('[name="select_submission_type_sd"]')
  );
};

/**
 * display:noneを使わずに非表示にする
 *
 * @param {HTMLElement|null} element
 */
const hideVisually = (element) => {
  if (!element) return;

  element.style.setProperty('visibility', 'hidden', 'important');
  element.style.setProperty('pointer-events', 'none', 'important');
  element.style.setProperty('height', '0px', 'important');
  element.style.setProperty('margin', '0px', 'important');
  element.style.setProperty('padding', '0px', 'important');
  element.style.setProperty('overflow', 'hidden', 'important');
};

/**
 * hideVisuallyを解除する
 *
 * @param {HTMLElement|null} element
 */
const showVisually = (element) => {
  if (!element) return;

  element.style.removeProperty('visibility');
  element.style.removeProperty('pointer-events');
  element.style.removeProperty('height');
  element.style.removeProperty('margin');
  element.style.removeProperty('padding');
  element.style.removeProperty('overflow');
};

/**
 * スマートデザインボタンクリック時の処理
 */
const handleSmartDesignClick = () => {
  const slug = window.location.pathname.split('/').pop() || '';
  const matchedKey = getBestMatchedKey(slug, allowedKeys);

  if (!matchedKey) {
    console.error(
      'Smart Design: 商品カテゴリを判定できませんでした。',
      slug,
    );

    return;
  }

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    console.error(
      'Smart Design: .product__info-containerが見つかりません。',
    );

    return;
  }

  const formData = {};
  let hasError = false;

  /**
   * 必須項目のバリデーション
   */
  const requiredLabels = productInfo.querySelectorAll(
    '.gpo-label.required',
  );

  requiredLabels.forEach((label) => {
    const field = label.parentElement?.querySelector(
      'input, select, textarea',
    );

    const isHidden =
      !field ||
      field.offsetParent === null ||
      field.disabled;

    if (!field || isHidden) {
      return;
    }

    // ファイル項目はスキップ
    if (field.type === 'file') {
      return;
    }

    const fieldType = field.type;
    const value = String(field.value ?? '').trim();

    let isEmpty = false;

    if (
      fieldType === 'checkbox' ||
      fieldType === 'radio'
    ) {
      const fieldName = field.getAttribute('name');

      if (fieldName) {
        const checkedField = productInfo.querySelector(
          `[name="${CSS.escape(fieldName)}"]:checked`,
        );

        isEmpty = !checkedField;
      } else {
        isEmpty = !field.checked;
      }
    } else {
      isEmpty = value === '';
    }

    if (isEmpty) {
      hasError = true;
    }
  });

  if (hasError) {
    alert('必須項目をすべて入力してください。');

    return;
  }

  /**
   * 商品カテゴリ
   */
  formData.productType = matchedKey;

  /**
   * 商品名
   */
  const productTitle = document
    .querySelector('.product__title > h1')
    ?.textContent?.trim();

  if (productTitle) {
    formData.productTitle = productTitle;
  }

  /**
   * 価格
   */
  const basePriceEl = document.querySelector(
    '.price-item.price-item--regular',
  );

  const basePrice = Number(
    basePriceEl?.textContent?.replace(/[^\d]/g, '') || 0,
  );

  formData.price = basePrice;

  /**
   * サイズ
   *
   * カード：60×90mm固定
   * お守り：40×65mm固定
   * その他：商品オプションの選択値
   */
  const sizeSelect = document.querySelector(
    '[name*="select_product_size"]',
  );

  const size =
    matchedKey === 'card'
      ? '60×90mm'
      : matchedKey === 'omamori_keyholder'
        ? '40×65mm'
        : sizeSelect?.value;

  if (!size) {
    alert(
      'サイズが不正のためデザインシミュレーター対象外です。',
    );

    return;
  }

  formData.size = size;

  /**
   * 丸カン追加
   */
  const jumpRingSelect = document.querySelector(
    '[name="select_has_jumpring_hole"]',
  );

  formData.hasJumpRing =
    jumpRingSelect?.value === '有り';

  /**
   * 台座印刷
   */
  const basePrintSelect = document.querySelector(
    '[name="select_has_base_print"]',
  );

  formData.hasBasePrint =
    basePrintSelect?.value === '印刷あり';

  /**
   * 台座形状
   */
  const baseShapeSelect = document.querySelector(
    '[name="select_base_shape"]',
  );

  const baseShape =
    baseShapeSelect?.value ?? '';

  const shapeValue = baseShapeName.find(
    (shape) => shape.label === baseShape,
  );

  formData.baseShape =
    shapeValue?.value ?? null;

  /**
   * 印刷面
   */
  const printFaceSelect = document.querySelector(
    '[name="side-quantity"]:checked',
  );

  formData.isPrintBothFaces = Boolean(
    printFaceSelect?.value?.includes('両面'),
  );

  /**
   * お守りの紐の色
   *
   * お守り以外の商品ではnull
   */
  if (matchedKey === 'omamori_keyholder') {
    const omamoriColorSelect = document.querySelector(
      '[name*="select_attachment"]',
    );

    const omamoriColor =
      omamoriColorSelect?.value?.trim();

    formData.omamoriColor =
      omamoriColor || null;
  } else {
    formData.omamoriColor = null;
  }

  console.log(
    'Created formData to use in Smart Design Simulator:',
    formData,
  );

  /**
   * React側に状態とデータをセット
   */
  window.smartDesignModalState = {
    isOpen: true,
    formData,
  };

  /**
   * React側へ変更通知イベントを送る
   */
  window.dispatchEvent(
    new CustomEvent('smartDesignStateChange', {
      detail: window.smartDesignModalState,
    }),
  );
};

/**
 * ボタンがDOM再生成されてもクリックできるよう、
 * documentにクリックイベントを委譲する
 */
if (!window.smartDesignClickHandlerRegistered) {
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest(
        SMART_BUTTON_SELECTOR,
      );

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      handleSmartDesignClick();
    },
    true,
  );

  window.smartDesignClickHandlerRegistered = true;
}

/**
 * スマート入稿ボタンの初期化
 *
 * @returns {boolean}
 */
const initSmartDesign = () => {
  // 商品詳細ページ以外では実行しない
  if (
    !window.location.pathname.includes('/products/')
  ) {
    return false;
  }

  const slug =
    window.location.pathname.split('/').pop() || '';

  const matchedKey = getBestMatchedKey(
    slug,
    allowedKeys,
  );

  if (!matchedKey) {
    return false;
  }

  const isAi = slug.includes('_ai');

  const gpoElement = document.querySelector(
    '.gpo-container',
  );

  if (!gpoElement && !isAi) {
    return false;
  }

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    return false;
  }

  const addToCartButton = document.querySelector(
    '.product-form__submit',
  );

  /**
   * AI商品の場合は、カートボタンが生成されるまで待つ
   */
  if (isAi && !addToCartButton) {
    return false;
  }

  /**
   * ボタンを作成または再利用
   */
  let button = document.querySelector(
    SMART_BUTTON_SELECTOR,
  );

  if (!button) {
    button = document.createElement('button');

    button.className = 'smart-design-button';
    button.type = 'button';
    button.dataset.smartDesignLaunch = 'true';
  }

  button.textContent = isAi
    ? '画像アップロードして作成開始'
    : 'デザインシミュレーターで作成開始';

  if (isAi) {
    button.style.marginBottom = '10px';
  } else {
    button.style.removeProperty('margin-bottom');
    button.style.display = 'none';
  }

  /**
   * AI商品ではカートボタンの直前に配置
   */
  if (isAi && addToCartButton) {
    const isCorrectPosition =
      button.parentElement ===
        addToCartButton.parentElement &&
      button.nextElementSibling === addToCartButton;

    if (!isCorrectPosition) {
      addToCartButton.insertAdjacentElement(
        'beforebegin',
        button,
      );
    }
  } else if (
    !isAi &&
    gpoElement &&
    !gpoElement.contains(button)
  ) {
    gpoElement.appendChild(button);
  }

  /**
   * 台座形状によりデザインシミュレーターを制御
   */
  const checkBaseShapeSelected = () => {
    const baseShapeSelect = document.querySelector(
      '[name="select_base_shape"]',
    );

    if (!baseShapeSelect) {
      return;
    }

    const baseShape =
      baseShapeSelect.options[
        baseShapeSelect.selectedIndex
      ]?.textContent?.trim();

    const submissionTypeSelect =
      getSubmissionTypeSelect();

    if (!submissionTypeSelect) {
      return;
    }

    const smartOption =
      submissionTypeSelect.querySelector(
        'option[value="デザインシミュレーター"]',
      );

    const isOriginalShape =
      baseShape ===
      '使用しない(オリジナルで形を作る)';

    if (isOriginalShape) {
      if (smartOption) {
        smartOption.style.display = 'none';
      }

      if (
        submissionTypeSelect.value ===
        'デザインシミュレーター'
      ) {
        const firstValidOption = Array.from(
          submissionTypeSelect.options,
        ).find((option) => {
          return (
            !option.disabled &&
            option.style.display !== 'none'
          );
        });

        if (firstValidOption) {
          submissionTypeSelect.value =
            firstValidOption.value;

          submissionTypeSelect.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
        }
      }
    } else if (smartOption) {
      smartOption.style.display = '';
    }
  };

  /**
   * 入稿方法によりボタン表示を切り替える
   */
  const checkSmartDesignSelected = () => {
    let isSmartDesignSelected = false;

    const addToCartButtons =
      document.querySelectorAll(
        '.product-form__submit',
      );

    const submissionTypeSelect =
      getSubmissionTypeSelect();

    if (submissionTypeSelect) {
      const selectedIndex =
        submissionTypeSelect.selectedIndex;

      if (selectedIndex >= 0) {
        const selectedOption =
          submissionTypeSelect.options[
            selectedIndex
          ];

        const selectedText =
          selectedOption?.textContent?.trim() || '';

        isSmartDesignSelected =
          selectedText.includes(
            'デザインシミュレーター',
          );
      }
    }

    /**
     * AI商品は常にスマートデザインボタンを表示
     */
    if (isSmartDesignSelected || isAi) {
      button.style.removeProperty('display');

      addToCartButtons.forEach((cartButton) => {
        hideVisually(cartButton);
      });

      return;
    }

    button.style.display = 'none';

    addToCartButtons.forEach((cartButton) => {
      showVisually(cartButton);
    });
  };

  checkBaseShapeSelected();
  checkSmartDesignSelected();

  /**
   * DOMが再生成されても変更を検知できるよう、
   * documentにchangeイベントを委譲
   */
  const handleChange = () => {
    checkBaseShapeSelected();
    checkSmartDesignSelected();
  };

  if (window.smartDesignHandleChange) {
    document.removeEventListener(
      'change',
      window.smartDesignHandleChange,
      true,
    );
  }

  window.smartDesignHandleChange =
    handleChange;

  document.addEventListener(
    'change',
    window.smartDesignHandleChange,
    true,
  );

  return true;
};

/**
 * MutationObserverによる再同期
 */
let smartDesignSyncScheduled = false;

const scheduleSmartDesignSync = () => {
  if (smartDesignSyncScheduled) {
    return;
  }

  smartDesignSyncScheduled = true;

  requestAnimationFrame(() => {
    smartDesignSyncScheduled = false;

    initSmartDesign();
    hideAllAiSelects();
  });
};

const observer = new MutationObserver(() => {
  scheduleSmartDesignSync();
});

const startSmartDesignObserver = () => {
  if (!document.body) {
    return;
  }

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  scheduleSmartDesignSync();
};

if (document.body) {
  startSmartDesignObserver();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    startSmartDesignObserver,
    {
      once: true,
    },
  );
}

/**
 * AI商品のselect項目をすべて非表示にする
 */
const hideAllAiSelects = () => {
  const slug =
    window.location.pathname.split('/').pop() || '';

  const matchedKey = getBestMatchedKey(
    slug,
    allowedKeys,
  );

  if (!matchedKey) {
    return;
  }

  const isAi = slug.includes('_ai');

  if (!isAi) {
    return;
  }

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    return;
  }

  const selects = productInfo.querySelectorAll('select');

  selects.forEach((select) => {
    const parentElement =
      select.closest('.gpo-element') ||
      select.closest('.product-form__input') ||
      select;

    hideVisually(parentElement);
  });
};

/**
 * DOMが安定するまで待機する
 *
 * @param {Function} callback
 * @param {number} checkInterval
 * @param {number} stableCount
 */
const waitForStableDOM = (
  callback,
  checkInterval = 100,
  stableCount = 3,
) => {
  let lastElementCount =
    document.getElementsByTagName('*').length;

  let stableFrames = 0;

  const intervalId = window.setInterval(() => {
    const currentElementCount =
      document.getElementsByTagName('*').length;

    if (
      currentElementCount === lastElementCount
    ) {
      stableFrames += 1;
    } else {
      stableFrames = 0;
      lastElementCount =
        currentElementCount;
    }

    if (stableFrames < stableCount) {
      return;
    }

    window.clearInterval(intervalId);

    callback();
  }, checkInterval);
};

/**
 * ページロード後にAI商品のselect項目を非表示にする
 */
window.addEventListener('load', () => {
  waitForStableDOM(() => {
    hideAllAiSelects();

    // select項目を非表示にした後にも再同期
    scheduleSmartDesignSync();
  });
});